// src/pages/AboutPage.jsx
import { Container, Row, Col } from "react-bootstrap";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import css from "./AboutUs.module.css";

// Reuse your existing components if you want
import MissionStatement from "./MissionStatement";
import Advantages from "./Advantages";

// If you have founder images, import them here
// import { ShubhamImg, YashImg, JatinImg } from "../assets/Images";

const founders = [
  {
    name: "Shubham Singh",
    role: "Co-Founder · Lead Engineer",
    bio: "Heads the technical direction at WebZova, turning ideas into fast, reliable, production-ready products using modern web and backend stacks.",
    // image: ShubhamImg,
  },
  {
    name: "Yash Ghai",
    role: "Co-Founder · Strategy & Operations",
    bio: "Focuses on business strategy, delivery, and client success—making sure every project ships on time and aligned with client goals.",
    // image: YashImg,
  },
  {
    name: "Jatin Jasuja",
    role: "Co-Founder · Product & Experience",
    bio: "Bridges design and development, crafting user experiences that feel simple on the surface and powerful under the hood.",
    // image: JatinImg,
  },
];

function AboutUs() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      offset: 80,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <div className={css.aboutPage} id="aboutUs">
      {/* Mission + stats */}
      <MissionStatement />

      {/* Advantages / Why Us */}
      <Advantages />

      {/* Founding Team */}
      <section className={css.foundersSection}>
        <Container>
          <div className={css.foundersHeader} data-aos="fade-up">
            <p className={css.kicker}>FOUNDING TEAM</p>
            <h2>The people behind WebZova.</h2>
            <p className={css.lead}>
              Three co-founders, one shared mindset: ship carefully crafted
              products, stay honest with clients, and keep learning fast.
            </p>
          </div>

          <Row className={css.foundersRow}>
            {founders.map((f, idx) => (
              <Col
                key={f.name}
                md={4}
                sm={12}
                className={css.founderCol}
                data-aos="fade-up"
                data-aos-delay={idx * 140}
              >
                <div className={css.founderCard}>
                  <div className={css.avatarWrap}>
                    {/* If you have real images, replace this circle with <img src={f.image} ... /> */}
                    <div className={css.avatarInitials}>
                      {f.name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .slice(0, 2)}
                    </div>
                  </div>
                  <h3>{f.name}</h3>
                  <p className={css.role}>{f.role}</p>
                  <p className={css.bio}>{f.bio}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default AboutUs;
